/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_History_Verb_Task_UpdatedInputs */

const en_case_history_verb_task_updated = /** @type {(inputs: Case_History_Verb_Task_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`updated`)
};

const pt_br2_case_history_verb_task_updated = /** @type {(inputs: Case_History_Verb_Task_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`atualizada`)
};

/**
* | output |
* | --- |
* | "updated" |
*
* @param {Case_History_Verb_Task_UpdatedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_history_verb_task_updated = /** @type {((inputs?: Case_History_Verb_Task_UpdatedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_History_Verb_Task_UpdatedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_history_verb_task_updated(inputs)
	return pt_br2_case_history_verb_task_updated(inputs)
});